
// https://stackoverflow.com/a/75093937
export const debounce = (func, delay = 600, immediate = false) => {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, delay);
		if (callNow) func.apply(context, args);
	};
};

export const sortAlphabetically = (arr, field) => {

	return arr.sort(function (a, b) {
		
		if (a && b){
			let x = field(a).toLowerCase()
			let y = field(b).toLowerCase()

			if (x < y)
				//sort string ascending
				return -1

			if (x > y) return 1

			return 0 //default return value (no sorting)
		}
		
		
	})
}

export const characterCount = (str, limit) => {
	return limit - str.length + " / " + limit
}

export const characterCountStyle = (str, limit) =>{
	let strLen = str.length
	let percentage = strLen / limit
	
	if (percentage > 1)  {
		return "text-danger"
	} else if (percentage < 1 && percentage >= 0.7) {
		return "text-warning"
	}

	return "text-muted"
}

//Used on keyup event
export const removeDoubleSpaces = (str) => {
	return str.replace(/\s+/g, ' ')
}

//Used on keyup event
export const removeLeadingSpace = (str) => {
	return str.replace(/^\s+/g, '')
}

export const adjustInputHeight = (e, maxHeight = 160) => {
	if (e != null) {
		const el = e.$el || e;
		if (!el || !el.style) return;

		if (el.scrollHeight === 0 && el.offsetHeight === 0) {
			return;
		}

		el.style.height = 'auto';
		const scrollHeight = el.scrollHeight;
		if (scrollHeight === 0) {
			return;
		}

		if (maxHeight && scrollHeight > maxHeight - 2) {
			el.style.height = maxHeight + 'px';
			el.style.overflowY = 'auto';
		} else {
			el.style.height = (scrollHeight + 2) + 'px';
			el.style.overflowY = 'hidden';
		}
		return el.style.height;
	}
}

// https://stackoverflow.com/a/5723274
/*
export const truncateLongText = (fullStrLen, strLenLimit, separator) => {
	if (fullStrLen.length <= strLenLimit) return fullStrLen;

	separator = separator || "...";

	var sepLen = separator.length,
		charsToShow = strLenLimit - sepLen
		// frontChars = Math.ceil(charsToShow / 2)
		// backChars = Math.floor(charsToShow / 2);


	return (fullStrLen.substr(0, charsToShow)).trim() + separator;
};
*/

export const truncateLongText = (fullStrLen, strLenLimit, separator) => {
	if (!fullStrLen) return "";
	if (typeof fullStrLen !== "string") fullStrLen = String(fullStrLen);
	if (fullStrLen.length <= strLenLimit) return fullStrLen;

	separator = separator || "...";

	var sepLen = separator.length,
		charsToShow = strLenLimit - sepLen;

	return (fullStrLen.substr(0, charsToShow)).trim() + separator;
};

// https://stackoverflow.com/a/5723274
/*
export const truncateLongTextWithSuffix = (fullStrLen, strLenLimit, separator) => {
	if (fullStrLen.length <= strLenLimit) return fullStrLen;

	separator = separator || "...";

	var sepLen = separator.length,
		charsToShow = strLenLimit - sepLen,
		frontChars = Math.ceil(charsToShow / 2),
		backChars = Math.floor(charsToShow / 2);

	return fullStrLen.substr(0, frontChars) + separator + fullStrLen.substr(fullStrLen.length - backChars);
};
*/

export const truncateLongTextWithSuffix = (fullStrLen, strLenLimit, separator) => {
	if (!fullStrLen) return "";
	if (typeof fullStrLen !== "string") fullStrLen = String(fullStrLen);
	if (fullStrLen.length <= strLenLimit) return fullStrLen;

	separator = separator || "...";

	var sepLen = separator.length,
		charsToShow = strLenLimit - sepLen,
		frontChars = Math.ceil(charsToShow / 2),
		backChars = Math.floor(charsToShow / 2);

	return fullStrLen.substr(0, frontChars) + separator + fullStrLen.substr(fullStrLen.length - backChars);
};

// export const toTitleCase = (str) => {
// 		return str.replace(/\w\S*/g, function (txt) {
// 			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
// 		});
// }

export const toTitleCase = (str) => {
   if (!str) return '';

   // A Set is used here because lookups are lightning fast (O(1) time complexity)
   const minorWords = new Set([
      'a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor',
      'on', 'at', 'to', 'from', 'by', 'of', 'in'
   ]);

   const words = str.toLowerCase().split(/\s+/);

   return words.map((word, index) => {
      // Capitalize if it's the first word, the last word, or NOT in our minor words set
      if (index === 0 || index === words.length - 1 || !minorWords.has(word)) {
         return word.charAt(0).toUpperCase() + word.slice(1);
      }
      
      // Otherwise, keep the minor word lowercase
      return word;
   }).join(' ');
};

// display icon based on file extension
export const getFileTypeIcon = (fileExt) => {
	// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
	let archive = ["arc", "bz", "bz2", "gz", "jar", "rar", "tar", "zip", "7z"];
	let audio = ["aac", "mid", "midi", "mp3", "oga", "opus", "wav", "weba"];
	let document = ["abw", "doc", "docx", "odt", "pdf"];
	let file = ["azw", "bin", "cda", "csh", "eot", "epub", "mpkg", "ogx", "otf", "sh", "ttf", "vsd", "woff", "woff2"];
	let image = ["avif", "bmp", "gif", "ico", "jpeg", "jpg", "png", "svg", "tif", "tiff", "webp"];
	let presentation = ["odp", "ppt", "pptx"];
	let spreadsheet = ["ods", "xls", "xlsx"];
	let text = ["css", "csv", "htm", "html", "ics", "js", "json", "jsonld", "mjs", "php", "rtf", "txt", "xhtml", "xml", "xul", "yaml"];
	let video = ["avi", "mkv", "mp4", "mpeg", "ogg", "ogv", "ts", "webm", "3gp", "3g2"];

	let fileTypeList = [
		{ type: "archive", values: archive },
		{ type: "audio", values: audio },
		{ type: "document", values: document },
		{ type: "file", values: file },
		{ type: "image", values: image },
		{ type: "presentation", values: presentation },
		{ type: "spreadsheet", values: spreadsheet },
		{ type: "text", values: text },
		{ type: "video", values: video },
	];

	let fileType = fileExt.replaceAll(".", "").trim().toLowerCase();
	let isImgExists = true
	
	// check if image icon is existing from folder, then use it else, check conditions below
	try {
		require("@/assets/img/file_type_icons/" + fileType + ".png");
	} catch(e) {
		isImgExists = false
	}

	if (!isImgExists) {
		
		fileType = fileTypeList.filter((type) => {
			return type.values.includes(fileType)
		}).map((e) => {return e.type}).toString()
		
		if (fileType == "document") {
			fileType = "doc";
		} else if (fileType == "image") {
			fileType = "jpg";
		} else if (fileType == "spreadsheet") {
			fileType = "xls";
		} else if (fileType == "presentation") {
			fileType = "ppt";
		} else if (fileType == "text") {
			fileType = "txt";
		} else if (fileType.trim() == "") {
			fileType = "file";
		}
		
	
	}

	return fileType + ".png";
}

// get mime type
export const getFileType = (fileExt) => {

	// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
	let archive = ["arc", "bz", "bz2", "gz", "jar", "rar", "tar", "zip", "7z"];
	let audio = ["aac", "mid", "midi", "mp3", "oga", "opus", "wav", "weba"];
	let document = ["abw", "doc", "docx", "odt", "pdf"];
	let file = ["azw", "bin", "cda", "csh", "eot", "epub", "mpkg", "ogx", "otf", "sh", "ttf", "vsd", "woff", "woff2"];
	let image = ["avif", "bmp", "gif", "ico", "jpeg", "jpg", "png", "svg", "tif", "tiff", "webp"];
	let presentation = ["odp", "ppt", "pptx"];
	let spreadsheet = ["ods", "xls", "xlsx"];
	let text = ["css", "csv", "htm", "html", "ics", "js", "json", "jsonld", "mjs", "php", "rtf", "txt", "xhtml", "xml", "xul", "yaml"];
	let video = ["avi", "mkv", "mp4", "mpeg", "ogg", "ogv", "ts", "webm", "3gp", "3g2"];

	let fileTypeList = [
		{ type: "archive", values: archive },
		{ type: "audio", values: audio },
		{ type: "document", values: document },
		{ type: "file", values: file },
		{ type: "image", values: image },
		{ type: "presentation", values: presentation },
		{ type: "spreadsheet", values: spreadsheet },
		{ type: "text", values: text },
		{ type: "video", values: video },
	];

	let fileType = fileExt.replaceAll(".", "").trim().toLowerCase();

	fileType = fileTypeList.filter((type) => {
			return type.values.includes(fileType)
		}).map((e) => {return e.type}).toString()

	return fileType
}

export const formatBytes = (bytes, decimals=2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function getBadgeStyle(colorCode, isSolid = false, fontSize = null) {
   // Use the provided color, or fallback to the default blue
   let hex = colorCode || '#00A0C1';
   hex = hex.replace('#', '');
   
   let styleObj = { border: 'none' };
   
   // Apply specific font size if requested
   if (fontSize) styleObj.fontSize = fontSize;

   if (hex.length === 6) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      
      styleObj.backgroundColor = isSolid ? `#${hex}` : `rgba(${r}, ${g}, ${b}, 0.15)`;
      styleObj.color = isSolid ? '#ffffff' : `#${hex}`;
   } else {
      // Fallback if the hex string is invalid
      styleObj.backgroundColor = isSolid ? '#00A0C1' : 'rgba(0, 160, 193, 0.15)';
      styleObj.color = isSolid ? '#ffffff' : '#00A0C1';
   }
   
   return styleObj;
}

export const isProductionEnvironment = () => {
   // 1. Check explicit build-time or runtime environment variables if provided
   const appEnv = (process.env.VUE_APP_ENV || process.env.VUE_APP_ENVIRONMENT || '').toLowerCase();
   if (appEnv) {
      if (['dev', 'development', 'uat', 'test', 'testing', 'local', 'sandbox', 'staging', 'preview'].includes(appEnv)) {
         return false;
      }
      if (['prod', 'production', 'live'].includes(appEnv)) {
         return true;
      }
   }

   // 2. Check window location hostname in browser
   if (typeof window !== 'undefined' && window.location) {
      const hostname = (window.location.hostname || '').toLowerCase();

      // Localhost / Loopback / Local network
      if (
         hostname === 'localhost' ||
         hostname === '127.0.0.1' ||
         hostname === '0.0.0.0' ||
         hostname.endsWith('.local') ||
         hostname.endsWith('.test')
      ) {
         return false;
      }

      // Non-production subdomains / domain patterns
      if (
         hostname.includes('dev') ||
         hostname.includes('uat') ||
         hostname.includes('np.vertexcybersecurity.com') ||
         hostname.includes('sandbox') ||
         hostname.includes('staging') ||
         hostname.includes('preview') ||
         hostname.includes('test')
      ) {
         return false;
      }
   }

   // 3. Check configured API / App base URLs
   const auditApiUrl = (process.env.VUE_APP_AUDIT_API_BASE_URL || '').toLowerCase();
   const auditBaseUrl = (process.env.VUE_APP_AUDIT_BASE_URL || '').toLowerCase();
   const authApiUrl = (process.env.VUE_APP_AUTH_API_BASE_URL || '').toLowerCase();
   const authBaseUrl = (process.env.VUE_APP_AUTH_BASE_URL || '').toLowerCase();
   const combinedUrls = `${auditApiUrl} ${auditBaseUrl} ${authApiUrl} ${authBaseUrl}`;

   if (
      combinedUrls.includes('localhost') ||
      combinedUrls.includes('127.0.0.1') ||
      combinedUrls.includes('dev') ||
      combinedUrls.includes('uat') ||
      combinedUrls.includes('np.vertexcybersecurity.com') ||
      combinedUrls.includes('sandbox') ||
      combinedUrls.includes('staging') ||
      combinedUrls.includes('test')
   ) {
      return false;
   }

   return true;
};

export const isProduction = isProductionEnvironment;